var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_891_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63527 18.557L6.05727 11.8339C6.11214 11.5745 5.94634 11.3198 5.68698 11.265C5.42762 11.2101 5.1729 11.3759 5.11804 11.6352L3.69604 18.3584C3.64117 18.6177 3.80697 18.8724 4.06633 18.9273C4.32569 18.9822 4.5804 18.8164 4.63527 18.557ZM18.0196 11.8355L19.4675 18.5636C19.5233 18.8228 19.7786 18.9877 20.0377 18.9319C20.2969 18.8761 20.4618 18.6208 20.406 18.3617L18.9581 11.6335C18.9023 11.3743 18.647 11.2095 18.3878 11.2652C18.1287 11.321 17.9638 11.5763 18.0196 11.8355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6747 9.0681L12.5602 4.87804C12.3116 4.77494 11.8437 4.77393 11.5944 4.87598L1.35523 9.06808L11.5946 13.26C11.8436 13.3621 12.3114 13.3611 12.5604 13.258L22.6747 9.06808V9.0681ZM12.9278 14.145C12.4448 14.345 11.714 14.3465 11.2307 14.1484L0.572792 9.7851C-0.190966 9.472 -0.190966 8.66369 0.573003 8.35101L11.2307 3.98756C11.7145 3.78956 12.4452 3.7911 12.9278 3.99121L23.4474 8.34909C24.2083 8.66413 24.2083 9.47205 23.4475 9.78707L12.9278 14.145ZM19.6936 18.049C17.3967 19.3981 14.7794 20.1198 12.0555 20.1198C9.32829 20.1198 6.708 19.3964 4.40916 18.0441C4.18067 17.9097 3.88648 17.9859 3.75207 18.2144C3.61765 18.4429 3.69392 18.7371 3.92241 18.8715C6.36778 20.31 9.15593 21.0798 12.0555 21.0798C14.9516 21.0798 17.7365 20.3119 20.1798 18.8767C20.4084 18.7424 20.4848 18.4483 20.3506 18.2197C20.2163 17.9911 19.9221 17.9147 19.6936 18.049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0605 8.9778V15.9208C23.0605 16.1859 23.2754 16.4008 23.5405 16.4008C23.8056 16.4008 24.0205 16.1859 24.0205 15.9208V8.9778C24.0205 8.7127 23.8056 8.4978 23.5405 8.4978C23.2754 8.4978 23.0605 8.7127 23.0605 8.9778Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_891_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.81a4a181f92c02ffe4eda17b22abd8f9.svg";
export { ForwardRef as ReactComponent };